import React from 'react';

const DropdownSectionIcon = () => (
  <svg
    width="36"
    height="20"
    viewBox="0 0 36 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 0L18 12.4324L31.8 0L36 3.78378L18 20L0 3.78378L4.5 0Z"
      fill="#2C2543"
    />
  </svg>
);

export default DropdownSectionIcon;
